import { ViewModel, View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { InvoiceDeliveryWarehouseStateEnumProvider, InvoicePaymentStateEnumProvider } from "src/Sell/invoicesList/invoicesList-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { DeliveryCartableCollectorViewModel } from "../deliveryCartableCollector/deliveryCartableCollector-viewModel";
import { DeliveryCartableDetailViewModel } from "../deliveryCartableDetail/deliveryCartableDetail-viewModel";
import { DeliveryFormViewModel } from "../deliveryForm/deliveryForm-viewModel";
import { DeliveryCartablesListView } from "./deliveryCartablesList-view"
import { RegisterForLocalNotification, UnregisterForLocalNotification } from "src/server/localNotification";

export class DeliveryCartablesListViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'کارتابل تحویل';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.deliveryCartable = ObservableArray.create<deliveryCartable>();
        this.invoiceDeliveryWarehouseStateEnumProvider = new InvoiceDeliveryWarehouseStateEnumProvider;
        this.invoicePaymentStateEnumProvider = new InvoicePaymentStateEnumProvider;
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 100);
        this._localNotificationHandeler = (command, parameter) => this.showDeliveryDetailForBarcode(command, parameter);
        let msg = new RegisterForLocalNotification("NewBarcodeRead", this._localNotificationHandeler);
        this.handleMessage(msg);

        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new DeliveryCartablesListView();
    }
    public getTypeId(): string {
        return "VM-C74C78D9-FC40-48A9-9A7C-6FF40FA50213"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set deliveryCartable(v: ObservableArray<deliveryCartable>) { this._deliveryCartable = v; } public get deliveryCartable(): ObservableArray<deliveryCartable> { return this._deliveryCartable; } private _deliveryCartable: ObservableArray<deliveryCartable>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set invoicePaymentStateEnumProvider(v: InvoicePaymentStateEnumProvider) { this._invoicePaymentStateEnumProvider = v; } public get invoicePaymentStateEnumProvider(): InvoicePaymentStateEnumProvider { return this._invoicePaymentStateEnumProvider; } private _invoicePaymentStateEnumProvider: InvoicePaymentStateEnumProvider;
    public set invoiceDeliveryWarehouseStateEnumProvider(v: InvoiceDeliveryWarehouseStateEnumProvider) { this._invoiceDeliveryWarehouseStateEnumProvider = v; } public get invoiceDeliveryWarehouseStateEnumProvider(): InvoiceDeliveryWarehouseStateEnumProvider { return this._invoiceDeliveryWarehouseStateEnumProvider; } private _invoiceDeliveryWarehouseStateEnumProvider: InvoiceDeliveryWarehouseStateEnumProvider;
    private _lastTimer;
    private _localNotificationHandeler;
    override requestClose(): boolean | Promise<boolean> {
        if (this._lastTimer != null) {
            clearTimeout(this._lastTimer);
        }
        let msg = new UnregisterForLocalNotification("NewBarcodeRead", this._localNotificationHandeler);
        this.handleMessage(msg);
        return super.requestClose();
    }
    refresh() {
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        if (this._lastTimer != null) {
            clearTimeout(this._lastTimer);
        }
        this._lastTimer = setTimeout(() => this.loader.refresh(), 60000)
        try {
            if (filteringInformation.OrderInfo.length == 0) {
                let sort = {
                    fieldName: 'createdTime',
                    order: 'DESC',
                    type: 'date'
                };
                filteringInformation.OrderInfo = [sort];
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/DeliveryCartableList', {
                FilteringInformation: filteringInformation,
            });
            this.deliveryCartable.update(...result.DeliveryCartables.map((q, i) => {
                let r = new deliveryCartable(this);
                r.rowNumber = i + 1;
                r.invoiceId = q.InvoiceId;
                r.invoiceWarehousePartId = q.InvoiceWarehousePartId;
                r.invoiceNumber = q.InvoiceNumber;
                r.createdDate = moment.utc(q.CreatedDate);
                r.warehouseId = q.WarehouseId;
                r.warehouseName = q.WarehouseName;
                r.customerName = q.CustomerName;
                r.amount = q.Amount;
                r.districtName = q.DistrictName;
                r.districtId = q.DistrictId;
                r.sellerName = q.SellerName;
                r.collectorId = q.CollectorId;
                r.collectorName = q.CollectorName;
                r.receiverName = q.ReceiverName;
                r.warehouseState = q.WarehouseState;
                r.invoiceWasEdited = q.InvoiceIsEdited;
                r.canCollect = r.warehouseId == q.DeliveryWarehouseId && (r.warehouseState == 0 || r.warehouseState == 1 || r.warehouseState == 2);
                r.canDelivery = q.CanDelivery;
                r.paymentState = q.PaymentState;
                r.notPaid = r.paymentState === 0;
                r.paid = (r.paymentState === 4) || (r.paymentState === 3);
                r.canceled = r.paymentState === 5;
                r.new = r.warehouseState === 0;
                if (r.new === true) {
                    r.notPaid = false;
                    r.paid = false;
                }
                r.paymentMethod = q.PaymentMethod;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    refreshClosePopups() {
        this.isShowingPopup = false;
        this.refresh();
    }

    async showDetail(id: string, warehousePartId: string) {
        let invoiceDetail = new DeliveryCartableDetailViewModel(this, id, warehousePartId);
        let result = await this.showPopup(invoiceDetail);
    }

    async showCollectorForm(id: string, warehousePartId: string, collectorId: string, warehouseId: string) {
        let collectorForm = new DeliveryCartableCollectorViewModel(this, id, warehousePartId, collectorId, warehouseId);
        let result = await this.showPopup(collectorForm);
        this.refresh();
    }

    async showDeliveryForm(id: string, warehousePartId: string) {
        let deliveryForm = new DeliveryFormViewModel(this);
        await deliveryForm.loadById(id, warehousePartId);
        if(deliveryForm.canDelivery == false){
            await this.messageBoxConfirmWarning("امکان تحویل این فاکتور وجود ندارد.", "تحویل فاکتور");
            return;
        }
        let result = await this.showPopup(deliveryForm);
        this.refresh();
    }

    async showDeliveryDetailForBarcode(command: string, parameter: any): Promise<void> {
        try{
            if (command == "NewBarcodeRead") {
                let parameters = parameter.Barcode.split(",");
                if (parameters.length >= 2) {
                    let invoiceId = parameters[0];
                    let warehosuePartId = parameters[1];
                    await this.showDeliveryForm(invoiceId, warehosuePartId);
                }
            }
        }catch(ex){
            console.log(ex);
        }
    }

}

export class deliveryCartable extends ViewModel {

    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: DeliveryCartablesListViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set invoiceWarehousePartId(v: string) { this._invoiceWarehousePartId = v; } public get invoiceWarehousePartId(): string { return this._invoiceWarehousePartId; } private _invoiceWarehousePartId: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId; } private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set invoiceId(v: string) { this._invoiceId = v; } public get invoiceId(): string { return this._invoiceId; } private _invoiceId: string;
    public set invoiceNumber(v: number) { this._invoiceNumber = v; } public get invoiceNumber(): number { return this._invoiceNumber; } private _invoiceNumber: number;
    public set createdDate(v: moment.Moment) { this._createdDate = v; } public get createdDate(): moment.Moment { return this._createdDate; } private _createdDate: moment.Moment;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName; } private _customerName: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId; } private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName; } private _sellerName: string;
    public set collectorName(v: string) { this._collectorName = v; } public get collectorName(): string { return this._collectorName; } private _collectorName: string;
    public set collectorId(v: string) { this._collectorId = v; } public get collectorId(): string { return this._collectorId; } private _collectorId: string;
    public set receiverName(v: string) { this._receiverName = v; } public get receiverName(): string { return this._receiverName; } private _receiverName: string;
    public set invoiceWasEdited(v: boolean) { this._invoiceWasEdited = v; } public get invoiceWasEdited(): boolean { return this._invoiceWasEdited; } private _invoiceWasEdited: boolean;
    public set canDelivery(v: boolean) { this._canDelivery = v; } public get canDelivery(): boolean { return this._canDelivery; } private _canDelivery: boolean;
    public set canCollect(v: boolean) { this._canCollect = v; } public get canCollect(): boolean { return this._canCollect; } private _canCollect: boolean;
    public set warehouseState(v: number) { this._warehouseState = v; } public get warehouseState(): number { return this._warehouseState; } private _warehouseState: number;
    public set paymentState(v: number) { this._paymentState = v; } public get paymentState(): number { return this._paymentState; } private _paymentState: number;
    public set paid(v: boolean) { this._paid = v; } public get paid(): boolean { return this._paid; } private _paid: boolean;
    public set notPaid(v: boolean) { this._notPaid = v; } public get notPaid(): boolean { return this._notPaid; } private _notPaid: boolean;
    public set canceled(v: boolean) { this._canceled = v; } public get canceled(): boolean { return this._canceled; } private _canceled: boolean;
    public set new(v: boolean) { this._new = v; } public get new(): boolean { return this._new; } private _new: boolean;

    public set paymentMethod(v: string) { this._paymentMethod = v; } public get paymentMethod(): string { return this._paymentMethod; } private _paymentMethod: string;

    private _typedParent: DeliveryCartablesListViewModel;

    async showDetail() {
        this._typedParent.showDetail(this.invoiceId, this.invoiceWarehousePartId);
    }

    async showCollectorForm() {
        this._typedParent.showCollectorForm(this.invoiceId, this.invoiceWarehousePartId, this.collectorId, this.warehouseId);
    }

    async showDeliveryForm() {
        this._typedParent.showDeliveryForm(this.invoiceId, this.invoiceWarehousePartId);
    }

}
